import { units } from "@m/alchemy-theme";
export const outerMargin = units(6, true);
export const gutterWidth = units(4, true);
export const gutterWidthHalf = gutterWidth * 0.5;
export const gutterWidthQuarter = gutterWidth * 0.25;
export const pageWidth = units(200, true);
export const gutterSizes = {
    large: `${gutterWidth}px`,
    medium: `${gutterWidthHalf}px`,
    small: `${gutterWidthQuarter}px`
};
